import React, { useEffect, useState, useRef } from "react";
import ReactDOM from "react-dom";
import styles from "./PaymentRestrict.module.css";
import warningIcon from "./Vector-3.svg";
import Modal from "common-ui-components/components/modal/Modal";
import Subscription from "app/settings/organization/subscription/Subscription";
import Manage from "app/settings/organization/subscription/manage-subscription/Manage";
import MailToSuperAdmin from "app/common/mail-to/MailToSuperAdmin";
import { isMspProduct, redirectToContactPage } from "utils/mspBasicUtils";

// container reference (singleton)
let container = null;
let currentPath = null;
let navigationPatched = false;

function patchNavigationOnce() {
  if (navigationPatched) return;
  navigationPatched = true;

  const notifyRouteChange = () => {
    if (container && window.location.pathname !== currentPath) {
      hidePaymentRestrict();
    }
  };

  window.addEventListener("popstate", notifyRouteChange);

  const originalPushState = window.history.pushState;
  window.history.pushState = function (...args) {
    const result = originalPushState.apply(this, args);
    notifyRouteChange();
    return result;
  };

  const originalReplaceState = window.history.replaceState;
  window.history.replaceState = function (...args) {
    const result = originalReplaceState.apply(this, args);
    notifyRouteChange();
    return result;
  };
}

// Function to render component into DOM
export const showPaymentRestrict = (shouldShake = false, action = null) => {
  if (container) return;

  patchNavigationOnce();
  currentPath = window.location.pathname;

  container = document.createElement("div");
  document.body.appendChild(container);

  ReactDOM.render(
    <PaymentRestrict shouldShake={shouldShake} action={action} />,
    container,
  );
};

export const hidePaymentRestrict = () => {
  if (container) {
    ReactDOM.unmountComponentAtNode(container);
    container.remove();
    container = null;
    currentPath = null;
  }
};

function PaymentRestrict({ shouldShake = false, action = null }) {
  const role = window.localStorage.getItem("UserRole");
  const plan = window.localStorage.getItem("Plan");

  // Shake state (initialized from prop)
  const [shake, setShake] = useState(shouldShake);

  // State to control nested modals
  const [open, setOpen] = useState(false);
  const [manageOpen, setManageOpen] = useState(false);

  // Shake reset logic (same as before)
  useEffect(() => {
    if (shake) {
      const timer = setTimeout(() => {
        setShake(false);
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [shake]);

  const handlePlanUpgrade = () => {
    if(isMspProduct()) {
        redirectToContactPage();
        return;
    }
    if (plan !== "Standard" && plan !== "Professional") {
      setOpen(true);
    } else {
      setManageOpen(true);
    }
  };

  return (
    <div className={styles["notification-wrapper"]}>
      <div className={`${styles.notification} ${shake ? styles.shake : ""}`}>
        <img src={warningIcon} alt="Warning" className={styles.icon} />
        <div className={styles.textContent}>
          <div className={styles.title}>
            <span>This feature requires a higher-tier edition. </span>
            {role === "Super Admin" ? (
              <span
                onClick={handlePlanUpgrade}
                style={{ color: "#0088FF", cursor: "pointer" }}
              >
                Upgrade now.
              </span>
            ) : (
              <div>
                Please contact your Super Admin{" "}
                <MailToSuperAdmin request={action} />
              </div>
            )}
          </div>
        </div>

        {/* Upgrade (Subscription) modal */}
        <Modal open={open} setOpen={setOpen}>
          <div
            style={{
              height: "99vh",
              width: "75vw",
            }}
          >
            {open && <Subscription settings={true} setIsPayment={setOpen} />}
          </div>
        </Modal>

        {/* Manage subscription modal */}
        <Modal open={manageOpen} setOpen={setManageOpen}>
          <div
            style={{
              height: "75vh",
              width: "70vw",
              padding: "1rem",
              overflowY: "hidden",
            }}
          >
            {manageOpen && <Manage modal={true} setOpen={setManageOpen} />}
          </div>
        </Modal>
      </div>
    </div>
  );
}

export default PaymentRestrict;